export default "__VITE_ASSET__DrYn2qXX__"